module.exports = __webpack_public_path__ + "static/media/Homepage_FPG_Assorti_Curcuma-Close.17353f6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Homepage/Homepage_FPG_Assorti_Curcuma-Close.jpg
// module id = 692
// module chunks = 0